import React, { Component } from 'react';

class NoteTableRowTemplate extends Component {
    render() {
        return this.props.dataItem.notes ?  <div><i className="u-icon u-icon--sml u-icon--note u-icon--text-top u-mar--right--tny"></i> {this.props.dataItem.notes} </div> : null ;
    }
}

export default NoteTableRowTemplate;